import { render } from "./BankOfChinaTab.vue?vue&type=template&id=21ce5d7c&scoped=true"
import script from "./BankOfChinaTab.vue?vue&type=script&lang=ts"
export * from "./BankOfChinaTab.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-21ce5d7c"

export default script